<script setup lang="ts">
import type { HotelFilterUpdate } from '@apps/main/new-desktop/modules/hotelFilters';
import { HotelFilters } from '@apps/main/new-desktop/modules/hotelFilters';

import { AppLinkButton } from '@libs/ui';

import { useHotelSelectionStore } from '../stores';

interface HotelSelectionFiltersPanelEmits {
  (eventName: 'close'): void;
  (eventName: 'update-filter', form: HotelFilterUpdate): void;
}

const emit = defineEmits<HotelSelectionFiltersPanelEmits>();

const hotelSelectionStore = useHotelSelectionStore();

function onUpdateFilter(filterUpdate: HotelFilterUpdate): void {
  emit('update-filter', filterUpdate);
}
</script>

<template>
  <div class="hotel-selection-filters-panel">
    <div class="filters-header">
      <span class="filters-header-label">{{ $t('filter.header') }}</span>
      <AppLinkButton
        class="reset-filters-button"
        :text="$t('planner.reset_hotel_filters')"
        size="large"
        @click="hotelSelectionStore.resetAllFilters"
      />
    </div>
    <HotelFilters
      class="filters-panel"
      theme="dark"
      :hide-filters-headers="true"
      :ingredient="hotelSelectionStore.editingStayIngredient"
      :max-length="25"
      @update-filter="onUpdateFilter"
    />
  </div>
</template>

<style scoped lang="scss">
.hotel-selection-filters-panel {
  display: flex;
  flex-direction: column;

  .filters-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--spacing-24);
    position: sticky;
    top: 0;
    background-color: var(--color-white);
    z-index: 1;

    .filters-header-label {
      color: var(--color-secondary-40);
      @include font-label-xxl-bold;
    }
  }

  .filters-panel {
    flex-grow: 1;
    padding: var(--spacing-24);
  }
}
</style>
